// extracted by mini-css-extract-plugin
module.exports = {"legacy":"Legacy-legacy-daIbFa","legacyLink":"Legacy-legacyLink-3bE6_8"};